import * as React from 'react';

export const RemoveIcon = () => {
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M23.71 1.71L22.29 0.290001L12 10.59L1.71004 0.290001L0.290039 1.71L10.59 12L0.290039 22.29L1.71004 23.71L12 13.41L22.29 23.71L23.71 22.29L13.41 12L23.71 1.71Z'
        fill='#3023AE'
      />
    </svg>
  );
};
